import styled from 'styled-components';
import {
    HIGHLIGHT_AND_CONTENT_EDITING_BEHAVIOR_CSS,
    FONT_PROPERTIES,
} from 'common/components/TouchpointEditor/components/TouchpointContainer';

export const HeadlineContent = styled.h3`
    ${FONT_PROPERTIES}
`;

export const ProviderLogoName = styled.div`
    ${(props) => props.providerLogoDisplay && `display: ${props.providerLogoDisplay}`};
    ${FONT_PROPERTIES};
`;

export const CalendarAttachmentWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: ${(props) => `${props.gap}px`};

    ${HIGHLIGHT_AND_CONTENT_EDITING_BEHAVIOR_CSS}
`;

export const LogoWrapper = styled.div`
    text-align: center;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 1rem;
    width: 100%;
`;

export const LogoLink = styled.a`
    color: ${(props) => props.$logoColor};
    cursor: pointer;
    &:hover {
        color: ${(props) => props.$logoColorHover};
    }
`;
